import { Button, Popover, Stack, Tooltip } from "@mantine/core";
import PopOver from "../../../../../components/View/PopOver";
import {
  IconChevronRight,
  IconCopy,
} from "@tabler/icons-react";
import { useLanguage } from "../../../../../stores/LanguageStore";
import LeadsCopyListDestination from "./LeadsCopyListDestination";
import {
  useLeadsContainerStore,
  useLeadsStore,
} from "../../../../../stores/LeadsStore";
import { transformFilterToServer } from "../../../../../functions/utilFunctions";

const LeadsCopyToList = ({ handleClose, tableFilter, tableSelection, handleFinish }) => {
  const query = useLeadsStore((s) => s.query);
  const globalFilter = useLeadsStore((s) => s.filter);
  const globalSelectedIds = useLeadsContainerStore((s) => s.selectedIds);
  const selectedColumns = useLeadsContainerStore((s) => s.selectedColumns);
  const lang = useLanguage((s) => s.language);

  const selectedIds = tableSelection || globalSelectedIds;
  const filter = tableFilter ? transformFilterToServer(tableFilter) : globalFilter;

  const canExportSelected = () => {
    if (Object.values(selectedIds).flatMap((x) => x).length > 0) {
      return true;
    }
    if (selectedColumns.length > 0) {
      return true;
    }

    return false;
  };

  return (
    <PopOver
      opener={(handleOpen, ref) => (
        <Button
          variant="light"
          justify="start"
          ref={ref}
          rightSection={<IconChevronRight size={16} />}
          leftSection={<IconCopy size={18} />}
          styles={{
            label: {
              marginRight: "auto",
            },
          }}
          onClick={handleOpen}
        >
          {lang.contact_lists.content.copy_selection.copy_prm}
        </Button>
      )}
      popoverChildren={(handleClose) => (
        <Stack gap={"xs"}>
          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_filter}
                disabled={filter || filter?.values?.length > 0 || query}
              >
                <Button
                  disabled={((!filter || !filter?.values.length === 0) && !query)}
                  variant="subtle"
                  size="sm"
                  color="tertiary.8"
                  justify="start"
                  rightSection={<IconChevronRight size={16} />}
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {lang.contact_lists.content.copy_selection.copy_filter}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsCopyListDestination
                handleClose={handleClose}
                type={"filter"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>
          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={canExportSelected()}
              >
                <Button
                  rightSection={<IconChevronRight size={16} />}
                  disabled={!canExportSelected()}
                  variant="subtle"
                  size="sm"
                  color="tertiary.8"
                  justify="start"
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {lang.contact_lists.content.copy_selection.copy_selection_prm}
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsCopyListDestination
                handleClose={handleClose}
                type={"selection"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>

          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Tooltip
                label={lang.contact_lists.delete_contacts.no_selection}
                disabled={canExportSelected()}
              >
                <Button
                  rightSection={<IconChevronRight size={16} />}
                  disabled={!canExportSelected()}
                  variant="subtle"
                  size="sm"
                  color="tertiary.8"
                  justify="start"
                  styles={{
                    label: {
                      marginRight: "auto",
                    },
                  }}
                >
                  {
                    lang.contact_lists.content.copy_selection
                      .copy_all_but_selection
                  }
                </Button>
              </Tooltip>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsCopyListDestination
                handleClose={handleClose}
                type={"selection_inverse"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>

          <Popover
            zIndex={1600}
            position="right"
            offset={0}
            shadow="md"
            withArrow
          >
            <Popover.Target>
              <Button
                rightSection={<IconChevronRight size={16} />}
                variant="subtle"
                size="sm"
                color="tertiary.8"
                justify="start"
                styles={{
                  label: {
                    marginRight: "auto",
                  },
                }}
              >
                {lang.contact_lists.content.copy_selection.copy_all_prm}
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <LeadsCopyListDestination
                handleClose={handleClose}
                type={"all"}
                onFinish={handleFinish}
                tableFilter={tableFilter}
                tableSelection={tableSelection}
              />
            </Popover.Dropdown>
          </Popover>
        </Stack>
      )}
    />
  );
};

export default LeadsCopyToList;
